module.exports = __webpack_public_path__ + "assets/error-icon.8955909dfb613c256f1cfc2a26ac4e15.png";